// import { Modal } from "antd";
// import {CheckOutlined, ExclamationOutlined } from "@ant-design/icons";
// import skinCareGif from "../../Assets/Images/AiReport/gif skin care.gif";
// import lungsCareGif from "../../Assets/Images/AiReport/LungsCare Gif.gif";
// import oralCareGif from "../../Assets/Images/AiReport/oral care gif.gif";
// import visionCareGif from "../../Assets/Images/AiReport/Visioncare gif.gif";
// const reportContent = {
//   skin_care: {
//   title :"Uploading your SkinCare image…",
//   description: "We’re securely uploading your image. This usually takes a few seconds.",
//   descriptionSuccess: "Your image has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand report tailored to your condition.",
//   titleSuccess: "Your image is successfully uploaded",
//   analyzingText: "Uploading your image…",
//   analyzingTextSuccess: "Your image upload is complete -analysis will begin next",
//   imageSrc: skinCareGif,
//   },
//   lung_care: { 
//   title :"Uploading your cough audio…",
//   description: "We’re securely uploading your audio. This usually takes a few seconds.",
//   descriptionSuccess: "Your audio has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand LungsCare report tailored to your condition.",
//   titleSuccess: "Your audio upload is complete -analysis will begin next",
//   analyzingText: "Uploading your audio…",
//   imageSrc: lungsCareGif,
//   analyzingTextSuccess: "Your audio upload is complete -analysis will begin next",
//   },
//   oral_care: {
//   title :"Uploading your OralCare image…",
//   description: "We’re securely uploading your image. This usually takes a few seconds.",
//   descriptionSuccess: "Your image has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand OralCare report tailored to your condition.",
//   titleSuccess: "Your image is successfully uploaded",
//   analyzingText: "Uploading your image…",
//   imageSrc: oralCareGif,
//   analyzingTextSuccess: "Your image upload is complete -analysis will begin next",
//   },
//   vision_care : {
//   title :"Uploading your Eye image…",
//   description: "We’re securely uploading your image. This usually takes a few seconds.",
//   descriptionSuccess: "Your eye image has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand report tailored to your condition.",
//   titleSuccess: "Your Eye Image is successfully uploaded",
//   analyzingText: "Uploading your image…",
//   imageSrc: visionCareGif,
//   analyzingTextSuccess: "Your eye image upload is complete -analysis will begin next",
//   },
// }

// export default function ReportUploadProgress({
//   solutionType,
//   progressLabel = "Your progress",
//   visible = true,
//   onCancel,
//   progress = 0,
//   onView,
// }) {
//   return (
//     <Modal open={visible} onCancel={onCancel} footer={null} centered width={680} style={{ maxWidth: '100vw' }}>
//       <div className="bg-white flex flex-col items-center text-center mx-auto" style={{fontFamily: "Inter",background: "radial-gradient(400px 637px at center, #00BB965E 0%, #00BB9612 40%, #D9D9D900 70%)"}}>
//       <h1 className="font-bold text-lg md:text-[24px] w-full md:w-[476px] mt-4" style={{color: "#49C285"}}>
//         {progress === 100 ? reportContent[solutionType].titleSuccess : reportContent[solutionType].title}
//       </h1>
//       <p className="font-medium text-sm md:text-base text-center w-11/12 md:w-4/5 mb-0" style={{color: "#666666"}}>
//         {progress === 100 ? reportContent[solutionType].descriptionSucess : reportContent[solutionType].description}
//       </p>
//       <img
//         src={reportContent[solutionType].imageSrc}                                  
//         alt="Analysis"
//         className="w-[280px] h-[210px] md:w-[416px] md:h-[312px] object-contain mx-auto mt-2"
//       />
//       <div className="px-4 md:px-6 w-11/12 md:w-9/12">
//       <div className="w-[30px] h-[30px] md:w-[35px] md:h-[35px] rounded-full mx-auto flex items-center justify-center mt-1 p-1" style={{ backgroundColor: progress === 100 ? "#198038" : "#FF8D28",}}>
//           <div className="text-black bg-transparent text-[16px] md:text-[20px] font-bold">
//             {progress === 100 ? <CheckOutlined /> : <ExclamationOutlined />}
//           </div>
//       </div>
//       <p className="font-inter font-bold text-sm md:text-[18px] my-1" style={{color: progress === 100 ? "#198038" : "#FF8D28"}}>
//         {progress === 100 ? reportContent[solutionType].analyzingTextSuccess : reportContent[solutionType].analyzingText}
//       </p>
//       <p className="font-bold text-xs leading-4 mb-0 text-left" style={{color: "#8D8D8D"}}>
//         {progressLabel}
//       </p>
//       <div className="flex justify-between items-center w-full">
//         <p className="font-lato font-bold text-base md:text-[18px] mb-0" style={{color: progress === 100 ? "#198038" : "#FF8D28"}}>{progress}% complete</p>
//       </div>
//       <div className="w-full h-[8px] md:h-[12px] bg-[#D2D2D2] rounded-full mt-4 overflow-hidden">
//         <div
//           className="h-full"
//           style={{
//             width: `${progress}%`,
//             backgroundColor: progress === 100 ? "#198038" : "#FF8D28",
//             transition: `${progress === 100 ? "width 0.6s ease" : "background-color 0.3s ease"}`,
//           }}
//         ></div>
//       </div>
//       </div>
//       <button
//         className="w-11/12 md:w-[364px] h-[40px] md:h-[48px] rounded-[24px] font-inter font-semibold text-sm md:text-[16px] mt-4 md:mt-8 text-White hover:opacity-90 active:opacity-80"
//         style={{ backgroundColor: progress === 100 ? "#001064" : "#D2D2D2" }}
//         onClick={() => { if (progress === 100) { onView && onView(); } }}
//       >
//         View Report
//       </button>
//       </div>
//     </Modal>
//   );
// }
import { Modal } from "antd";
import { CheckOutlined, ExclamationOutlined } from "@ant-design/icons";
import skinCareGif from "../../Assets/Images/AiReport/gif skin care.gif";
import lungsCareGif from "../../Assets/Images/AiReport/LungsCare Gif.gif";
import oralCareGif from "../../Assets/Images/AiReport/oral care gif.gif";
import visionCareGif from "../../Assets/Images/AiReport/Visioncare gif.gif";

const reportContent = {
  skin_care: {
    title: "Uploading your SkinCare image…",
    description: "We’re securely uploading your image. This usually takes a few seconds.",
    descriptionSuccess:
      "Your image has been uploaded and will now be analyzed by our AI to generate an accurate, easy-to-understand report tailored to your condition.",
    titleSuccess: "Your image is successfully uploaded",
    analyzingText: "Uploading your image…",
    analyzingTextSuccess: "Your image upload is complete - analysis will begin next",
    imageSrc: skinCareGif,
  },
  lung_care: {
    title: "Uploading your cough audio…",
    description: "We’re securely uploading your audio. This usually takes a few seconds.",
    descriptionSuccess:
      "Your audio has been uploaded and will now be analyzed by our AI to generate an accurate report.",
    titleSuccess: "Your audio upload is complete",
    analyzingText: "Uploading your audio…",
    analyzingTextSuccess: "Your audio upload is complete - analysis will begin next",
    imageSrc: lungsCareGif,
  },
  oral_care: {
    title: "Uploading your OralCare image…",
    description: "We’re securely uploading your image. This usually takes a few seconds.",
    descriptionSuccess:
      "Your image has been uploaded and will now be analyzed by our AI.",
    titleSuccess: "Your image is successfully uploaded",
    analyzingText: "Uploading your image…",
    analyzingTextSuccess: "Your image upload is complete - analysis will begin next",
    imageSrc: oralCareGif,
  },
  vision_care: {
    title: "Uploading your Eye image…",
    description: "We’re securely uploading your image. This usually takes a few seconds.",
    descriptionSuccess:
      "Your eye image has been uploaded and will now be analyzed by our AI.",
    titleSuccess: "Your Eye Image is successfully uploaded",
    analyzingText: "Uploading your image…",
    analyzingTextSuccess: "Your eye image upload is complete - analysis will begin next",
    imageSrc: visionCareGif,
  },
};

export default function ReportUploadProgress({
  solutionType,
  progressLabel = "Your progress",
  visible = true,
  onCancel,
  progress = 0,
  onView,
}) {
  const data = reportContent[solutionType];

  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered width={680}>
      <div
        className="flex flex-col items-center text-center mx-auto"
        style={{
          fontFamily: "Inter",
          background:
            "radial-gradient(400px 637px at center, #00BB965E 0%, #00BB9612 40%, #D9D9D900 70%)",
        }}
      >
        {/* ✅ TITLE (GRADIENT FIXED) */}
        <h1
          className="font-bold text-lg md:text-[24px] w-full md:w-[476px] mt-4"
          style={{
            background:
              "var(--primary-gradient)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {progress === 100 ? data.titleSuccess : data.title}
        </h1>

        {/* ✅ DESCRIPTION FIXED (typo fixed here) */}
        <p className="font-medium text-sm md:text-base text-center w-11/12 md:w-4/5 mb-0 text-[#666666]">
          {progress === 100 ? data.descriptionSuccess : data.description}
        </p>

        {/* IMAGE */}
        <img
          src={data.imageSrc}
          alt="Analysis"
          className="w-[280px] h-[210px] md:w-[416px] md:h-[312px] object-contain mx-auto mt-2"
        />

        <div className="px-4 md:px-6 w-11/12 md:w-9/12">
          {/* ICON */}
          <div
            className="w-[35px] h-[35px] rounded-full mx-auto flex items-center justify-center mt-1"
            style={{
              backgroundColor: progress === 100 ? "#198038" : "#FF8D28",
            }}
          >
            {progress === 100 ? <CheckOutlined /> : <ExclamationOutlined />}
          </div>

          {/* ANALYZING TEXT */}
          <p
            className="font-bold text-sm md:text-[18px] my-1"
            style={{
              color: progress === 100 ? "#198038" : "#FF8D28",
            }}
          >
            {progress === 100
              ? data.analyzingTextSuccess
              : data.analyzingText}
          </p>

          {/* PROGRESS */}
          <p className="text-xs text-[#8D8D8D] text-left">{progressLabel}</p>

          <p
            className="font-bold text-base md:text-[18px]"
            style={{
              color: progress === 100 ? "#198038" : "#FF8D28",
            }}
          >
            {progress}% complete
          </p>

          {/* BAR */}
          <div className="w-full h-[10px] bg-[#D2D2D2] rounded-full mt-3 overflow-hidden">
            <div
              className="h-full"
              style={{
                width: `${progress}%`,
                backgroundColor: progress === 100 ? "#198038" : "#FF8D28",
              }}
            />
          </div>
        </div>

        {/* ✅ BUTTON FIXED */}
        <button
          className="w-11/12 md:w-[364px] h-[44px] rounded-full font-semibold text-sm md:text-[16px] mt-6 text-white"
          style={{
            background: progress === 100 ? "var(--color-brand-primary)" : "#D2D2D2",
            cursor: progress === 100 ? "pointer" : "not-allowed",
          }}
          onClick={() => {
            if (progress === 100) onView && onView();
          }}
        >
          View Report
        </button>
      </div>
    </Modal>
  );
}